import React from "react";
import { Link } from "react-router-dom";
import { Heart, ShoppingCart, Trash2 } from "lucide-react";
import EmptyState from "@/components/common/EmptyState";
import { formatPrice } from "@/lib/format";
import { useApp } from "@/context/AppContext";
import { useI18n } from "@/i18n/I18nProvider";

export default function WishlistPage() {
  const { t } = useI18n();
  const { wishlist, toggleWishlist, addToCart } = useApp();

  return (
    <div className="mx-auto max-w-7xl px-4 py-8">
      <h1 className="mb-6 font-display text-2xl font-bold text-ink sm:text-3xl">{t("wishlist")}</h1>
      {wishlist.length === 0 ? (
        <EmptyState icon={Heart} title={t("wishlist")} body={t("cart_empty_body")} action={<Link to="/shop" className="rounded-full bg-ink px-6 py-2.5 text-sm font-semibold text-white">{t("continue_shopping")}</Link>} />
      ) : (
        <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4" data-testid="wishlist-grid">
          {wishlist.map((p) => (
            <div key={p.id} className="flex flex-col overflow-hidden rounded-2xl border border-border bg-card">
              <Link to={`/product/${p.slug}`} className="aspect-square overflow-hidden bg-secondary">
                {p.image && <img src={p.image} alt={p.name} className="h-full w-full object-cover" />}
              </Link>
              <div className="flex flex-1 flex-col p-3">
                <Link to={`/product/${p.slug}`} className="line-clamp-2 text-sm font-medium text-ink hover:text-brand">{p.name}</Link>
                <span className="mt-2 font-display text-lg font-bold text-ink">{formatPrice(p.price, p.currency)}</span>
                <div className="mt-auto flex gap-2 pt-3">
                  <button onClick={() => { addToCart(p, 1); toggleWishlist(p); }} className="flex h-10 flex-1 items-center justify-center gap-1.5 rounded-full bg-ink text-sm font-semibold text-white hover:bg-brand" data-testid={`wishlist-add-cart-${p.id}`}>
                    <ShoppingCart size={15} /> {t("add_to_cart")}
                  </button>
                  <button onClick={() => toggleWishlist(p)} className="grid h-10 w-10 place-items-center rounded-full border border-border hover:border-brand hover:text-brand" data-testid={`wishlist-remove-${p.id}`}>
                    <Trash2 size={16} />
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
